const dialogNames = {
  DELETE_RESOURCE: "DELETE_RESOURCE",
  HARD_DELETE_RESOURCE: "HARD_DELETE_RESOURCE",
  RENAME_RESOURCE: "RENAME_RESOURCE",
  ADD_FOLDER: "ADD_FOLDER",
  ADD_PROMPT: "ADD_PROMPT",
  COPY_PROMPT: "COPY_PROMPT",
  COPY_EVAL: "COPY_EVAL",
  SAVE_PROMPT_VERSION: "SAVE_PROMPT_VERSION",
  SAVE_NEW_EVAL_PROMPT: "SAVE_NEW_EVAL_PROMPT",
  SAVE_EVAL_PROMPT_VERSION: "SAVE_EVAL_PROMPT_VERSION",
  RENAME_TEST_CASE: "RENAME_TEST_CASE",
  SHARE_RESOURCE: "SHARE_RESOURCE",
  UPLOAD_FILES: "UPLOAD_FILES",
  ADD_FILE_VARIABLE: "ADD_FILE_VARIABLE",
  SIGNUP_INTERRUPTION: "SIGNUP_INTERRUPTION",
  PROVIDER_API_KEY: "PROVIDER_API_KEY",
  DELETE_PROVIDER_API_KEY: "DELETE_PROVIDER_API_KEY",
  PRICING_UPSELL: "PRICING_UPSELL",
  SCHEMA_BUILDER: "SCHEMA_BUILDER",
  TOOL_BUILDER: "TOOL_BUILDER",
} as const;

export { dialogNames };
